import * as tslib_1 from "tslib";
import axios from 'axios';
import { ContextTokenService } from '../social-content';
function getActivitiesApiUrl(origin) {
    if (origin.includes('localhost')) {
        return '/_api/social-content/v1';
    }
    return '/social-content/api/v1';
}
/**
 * ActivityApi - client for groups activity api
 * https://github.com/wix-private/catalyst-server/tree/master/social-content/social-content-api/src/main/proto/wix/social
 *
 */
var ActivityApi = /** @class */ (function () {
    /**
     * @param {string} token - jwt for site instance
     * (see [more](https://github.com/wix-private/platformization-guidelines/blob/master/guides/instance.md#instance))
     */
    function ActivityApi(token, apiUrl) {
        this.token = token;
        this.axios = axios.create({
            baseURL: getActivitiesApiUrl(apiUrl),
            headers: {
                Authorization: token,
            },
        });
        this.tokenService = new ContextTokenService(token, apiUrl);
    }
    ActivityApi.prototype.getActivities = function (groupId, query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, params;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = query;
                        return [4 /*yield*/, this.getGroupContextToken(groupId)];
                    case 1:
                        _a.contextTokens = [_b.sent()];
                        params = this.buildQueryString(query);
                        return [2 /*return*/, this.axios.get("/activities/stats?" + params.toString())];
                }
            });
        });
    };
    ActivityApi.prototype.getGroupContextToken = function (groupId) {
        return this.tokenService.getContextToken(groupId);
    };
    ActivityApi.prototype.getLatestActivities = function (groupIds, query) {
        if (query === void 0) { query = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contextTokens;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.getContextTokens(groupIds)];
                    case 1:
                        contextTokens = _a.sent();
                        query.contextTokens = contextTokens;
                        query.activityTypes = ['wix.feed.activities.PostedInFeed'];
                        return [2 /*return*/, this.axios.post("/activities/latest/query", query)];
                }
            });
        });
    };
    ActivityApi.prototype.buildQueryString = function (query) {
        var e_1, _a;
        var contextTokens = query.contextTokens, activityTypes = query.activityTypes, time = query.time;
        var params = new URLSearchParams();
        try {
            for (var contextTokens_1 = tslib_1.__values(contextTokens), contextTokens_1_1 = contextTokens_1.next(); !contextTokens_1_1.done; contextTokens_1_1 = contextTokens_1.next()) {
                var token = contextTokens_1_1.value;
                params.append('contextTokens', token);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (contextTokens_1_1 && !contextTokens_1_1.done && (_a = contextTokens_1.return)) _a.call(contextTokens_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        params.set('activityTypes', activityTypes || 'wix.feed.activities.PostedInFeed');
        var _b = time || {}, from = _b.from, to = _b.to;
        from && params.set('time.from', from);
        to && params.set('time.to', to);
        return params;
    };
    return ActivityApi;
}());
export { ActivityApi };
//# sourceMappingURL=ActivityApi.js.map